import moment from 'moment'
import api from '@/utils/api'

class SyncItem {
  constructor (name, options = {}) {
    this.name = name
    this.callback = options.callback || function () {}
    this.beforeCallback = options.before || function () {}
    this.interval = options.interval || 1000
    this.failCallback = options.fail || function () {}
    this.alwaysCallback = options.always || function () {}
    this.parametersCallback = options.parameters || (() => ({}))
    this.lastTimeStrategy = options.lastTimeStrategy || function (at = null) {}
      // at can be "enable", "resync", "start", "disable"
    this.nextTime = moment()
    this.lastCallTime = this.nextTime.clone()
    this.applyLastTimeStrategy('start')
    this.nextTime.add(this.interval, 'ms')
    this.enabled = true
  }

  getName () {
    return this.name
  }

  isNamed (name) {
    return this.name === name
  }

  callFn (fn, args) {
    if (args == null) { args = [] }
    return fn.apply(this, args)
  }

  before () {
    if (this.enabled) {
      return this.callFn(this.beforeCallback)
    }
  }

  call (data) {
    if (this.enabled) {
      return this.callFn(this.callback, [data])
    }
  }
  fail (data) {
    if (this.enabled) {
      return this.callFn(this.failCallback, [data])
    }
  }

  always (data) {
    if (this.enabled) {
      return this.callFn(this.alwaysCallback, [data])
    }
  }

  resync (aMoment) {
    this.nextTime = aMoment.clone()
    // this.nextTime.add(this.interval, 'ms')
    return this.applyLastTimeStrategy('resync')
  }

  getLastUpdateTime () {
    return this.lastCallTime
  }

  needToBeCalled (now) {
    return this.enabled && now.isSameOrAfter(this.nextTime)
  }

  updateNextTime (m) {
    this.lastCallTime = this.nextTime.clone()
    this.nextTime = m.clone()
    return this.nextTime.add(this.interval, 'ms')
  }

  nextCallAt (m) {
    this.nextTime = m.clone()
  }

  disable () {
    this.enabled = false
    return this.applyLastTimeStrategy('disable')
  }

  enable () {
    if (this.enabled) {
      return
    }
    this.enabled = true
    this.applyLastTimeStrategy('enable')
    this.nextTime = moment()
    return this.nextTime.add(this.interval, 'ms')
  }

  applyLastTimeStrategy (at) {
    const newValue = this.callFn(this.lastTimeStrategy, [at])
    if (newValue != null) {
      this.lastCallTime = newValue
    }
  }

  getParameters () {
    return this.callFn(this.parametersCallback)
  }
}

// ///////////////////////////

class Sync {
  constructor (options = {}) {
    this.items = []
    this.intervalTime = options.intervalTime || 1000
    this.interval = null
    this.startInterval()
    this.sending = false
  }

  addSyncItem (name, options) {
    if (options == null) { options = {} }
    const item = new SyncItem(name, options)
    this.resyncItems(item)
    this.items.push(item)
    return this
  }

  resyncItems (newItem = null) {
    const m = moment()
    for (let item of Array.from(this.items)) {
      item.resync(m)
    }
    if (newItem != null) {
      return newItem.resync(m)
    }
  }

  addOnlyOnceSyncItem (name, options) {
    if ((this.itemWithName(name) == null)) {
      this.addSyncItem(name, options)
    }
    return this
  }

  removeSyncItem (name) {
    this.items = this.items.filter(x => !x.isNamed(name))
    return this
  }

  disableSyncItem (name) {
    for (let item of Array.from(this.items)) {
      if (item.isNamed(name)) {
        item.disable()
      }
    }
    return this
  }

  enableSyncItem (name) {
    for (let item of Array.from(this.items)) {
      if (item.isNamed(name)) {
        item.enable()
      }
    }
    this.resyncItems()
    return this
  }

  itemWithName (name) {
    return this.items.find(x => x.isNamed(name))
  }

  startInterval () {
    this.interval = setInterval(() => {
      return this.sendCall()
    }
    , this.intervalTime)
    return this
  }

  callASAP (name) {
    const m = moment()
    for (let item of Array.from(this.items)) {
      if (item.isNamed(name)) {
        item.nextCallAt(m)
      } else {
        item.resync(m)
      }
    }
    return this
  }

  sendCall () {
    if (this.sending) {
      return
    }
    this.sending = true
    const m = moment()
    const itemsToCall = []
    const dataToSend = []

    for (var item of Array.from(this.items)) {
      if (item.needToBeCalled(m)) {
        itemsToCall.push(item)
        dataToSend.push({
          name: item.getName(),
          lastUpdateTime: item.getLastUpdateTime().unix(),
          data: item.getParameters()
        })
        item.updateNextTime(m)
        item.before()
      }
    }
    if (itemsToCall.length > 0) {
      return api.get('/updates',
        {
          params: {
            services: dataToSend
          }
        }).then(response => {
          let data = response.data
          const result = []
          for (let key in data) {
            const value = data[key]
            item = this.itemWithName(key)
            if (item != null) {
              result.push(item.call(value))
            } else {
              result.push(undefined)
            }
          }
          return result
        }).catch(response => {
          return (() => {
            let data = response.data
            const result = []
            for (item of Array.from(itemsToCall)) {
              result.push(item.fail(data))
            }
            return result
          })()
        }).then(response => {
          let data = response.data
          for (item of Array.from(itemsToCall)) {
            item.always(data)
          }
          this.sending = false
        })
    } else {
      this.sending = false
    }
  }
}

// ///////////////////////////

export default Sync



// WEBPACK FOOTER //
// ./src/utils/sync.js